import { useEffect, useState } from 'react';

export type Badge = {
  label: Record<string, string>;
  icon?: Record<string, any>;
  styles?: Record<string, any>;
  visibility?: Record<string, any>;
  ranking?: number;
  conditions?: { badgeCodeCsv?: string };
  _meta?: any;
  variantCodes?: string[];
};

export function useBadgeLoader(p1BadgeData: Badge[]) {
  const [badgesWithVariants, setBadgesWithVariants] = useState<Badge[]>([]);

  useEffect(() => {
    async function load() {
      const results: Badge[] = [];

      await Promise.all(
        p1BadgeData?.map(async (badge) => {
          const csvUrl = badge?.conditions?.badgeCodeCsv;
          if (!csvUrl) return;

          try {
            const res = await fetch(csvUrl);
            const text = await res?.text();
            const lines = text?.trim()?.split('\n');
            const variantCodes = lines
              ?.slice(1)
              ?.map((line) => line.split(',')[0]?.trim())
              ?.filter(Boolean);

            results?.push({
              ...badge,
              variantCodes,
            });
          } catch (err) {
            console.error(`Failed to fetch badge CSV from ${csvUrl}`, err);
          }
        }),
      );

      setBadgesWithVariants(results);
    }

    if (p1BadgeData?.length) {
      load();
    }
  }, [p1BadgeData]);

  return badgesWithVariants;
}
